<agpr-take-over-panel
    id="agpr_aiContextTakeover"
    class="agpr-aiContextTakeover"
    [splitHeader]="panelHeader"
    [overlayContainer]="overlayContainer"
    [hideSlideOverlay]="hideSlideOverlay"
    [animationTrigger]="animationTrigger"
    (visibleChange)="handleVisibleChange($event)"
    [minPanelWidth]="900"
    [maxPanelWidth]="1200"
    [responsiveWidth]="true"
    [noScroll]="true"
    [noPadding]="true"
>
    <ng-template #noScrollContent>
        <div class="agpr-aiContextTakeover-content">
            <div class="agpr-aiContextTakeover-columns">
                <!-- Left: questions panel -->
                <div class="agpr-aiContextTakeover-chat">
                    <div class="agpr-aiContextTakeover-description">
                        {{ descriptionLabel | localize }}
                    </div>
                    <div
                        id="agpr_aiContextTakeover_refined_search-status"
                        class="sr-only"
                        role="status"
                        aria-live="polite"
                    >
                    @if (!isLoading) {
                        <!-- Include the last static question -->
                        @let questionCount = pendingQuestions.length + 1;
                        @let translationKey = questionCount > 1 ? 'Common.prcopilot.updateSearchCompleted.other' : 'Common.prcopilot.updateSearchCompleted.one';
                        {{ translationKey | localize:{ questionCount } }}
                    }
                    </div>
                    <agpr-scroll-panel
                        id="agpr_aiContextTakeover_questions"
                        class="agpr-aiContextTakeover-chatMessages"
                    >
                        @if (isLoading) {
                            <div class="agpr-aiContextTakeover-placeholder">
                                <div class="agpr-aiContextTakeover-placeholderQuestion">
                                    <div class="agpr-aiContextTakeover-placeholderLine agpr-aiContextTakeover-placeholderHeading">
                                        <div class="agpr-aiContextTakeover-placeholderShimmer"></div>
                                    </div>
                                </div>
                                <div class="agpr-aiContextTakeover-placeholderQuestion agpr-aiContextTakeover-placeholder--opacity8">
                                    <div class="agpr-aiContextTakeover-placeholderLine agpr-aiContextTakeover-placeholderHeading">
                                        <div class="agpr-aiContextTakeover-placeholderShimmer"></div>
                                    </div>
                                </div>
                                <div class="agpr-aiContextTakeover-placeholderQuestion agpr-aiContextTakeover-placeholder--opacity6">
                                    <div class="agpr-aiContextTakeover-placeholderLine agpr-aiContextTakeover-placeholderHeading">
                                        <div class="agpr-aiContextTakeover-placeholderShimmer"></div>
                                    </div>
                                </div>
                                <div class="agpr-aiContextTakeover-placeholderQuestion agpr-aiContextTakeover-placeholder--opacity4">
                                    <div class="agpr-aiContextTakeover-placeholderLine agpr-aiContextTakeover-placeholderHeading">
                                        <div class="agpr-aiContextTakeover-placeholderShimmer"></div>
                                    </div>
                                </div>
                            </div>
                        } @else {
                            @for (question of pendingQuestions; track question.id) {
                                <div class="agpr-aiContextTakeover-question">
                                    <div class="agpr-aiContextTakeover-chatQuestionHeadingRow">
                                        <div class="agpr-aiContextTakeover-chatQuestionHeading">
                                            {{ question.question }}
                                            @if(ignoredQuestions[question.id]) {
                                                <span class="agpr-aiContextTakeover-chatQuestionIgnoredLabel">({{ 'Common.prcopilot.ignored' | localize }})</span>
                                            }
                                        </div>
                                        <agpr-button
                                            [id]="'agpr_aiContextTakeover_ignore_' + question.id"
                                            [tooltip]="ignoredQuestions[question.id] ? ('Common.prcopilot.includeQuestion' | localize) : ('Common.prcopilot.ignoreQuestion' | localize)"
                                            class="agpr-aiContextTakeover-chatQuestionIgnore"
                                            [class.agpr-aiContextTakeover-chatQuestionIgnore--active]="ignoredQuestions[question.id]"
                                            [icon]="ignoredQuestions[question.id] ? 'fa-duotone fa-regular fa-square-plus' : 'fa-duotone fa-regular fa-square-xmark'"
                                            [style]="buttonTypes.icon"
                                            (click)="ignoreQuestion(question.id)"
                                        ></agpr-button>
                                    </div>

                                    @switch (question.type) {
                                        @case ('text_array') {
                                            <div class="agpr-aiContextTakeover-chatQuestionChipInput">
                                                <agpr-text-input-chips
                                                    [id]="'agpr_aiContextTakeover_chips_' + question.id"
                                                    [(ngModel)]="questionStates[question.id].chipsValue"
                                                    [splitOnPattern]="splitOnPattern"
                                                    [disabled]="ignoredQuestions[question.id]"
                                                    (ngModelChange)="updateHasAnswers()"
                                                ></agpr-text-input-chips>
                                            </div>
                                        }
                                        @case ('multi_select') {
                                            @if ((question.options?.length ?? 0) > multiSelectDropdownThreshold) {
                                                <div class="agpr-aiContextTakeover-chatQuestionChipInput">
                                                    <agpr-multi-select-dropdown
                                                        [id]="'agpr_aiContextTakeover_multiSelect_' + question.id"
                                                        [optionsList]="getOptionsAsList(question)"
                                                        [(ngModel)]="questionStates[question.id].selectedOptions"
                                                        [disabled]="ignoredQuestions[question.id]"
                                                        (ngModelChange)="updateHasAnswers()"
                                                    ></agpr-multi-select-dropdown>
                                                </div>
                                            } @else {
                                                <div class="agpr-aiContextTakeover-chatQuestionOptions">
                                                    @for (option of question.options ?? []; track option) {
                                                        <agpr-checkbox
                                                            [id]="'agpr_aiContextTakeover_option_' + question.id + '_' + $index"
                                                            [label]="option"
                                                            [value]="option"
                                                            [binary]="false"
                                                            [(ngModel)]="questionStates[question.id].selectedOptions"
                                                            [disabled]="ignoredQuestions[question.id]"
                                                            (ngModelChange)="updateHasAnswers()"
                                                        ></agpr-checkbox>
                                                    }
                                                </div>
                                            }
                                        }
                                        @case ('single_select') {
                                            <div class="agpr-aiContextTakeover-chatQuestionOptions">
                                                @for (option of question.options ?? []; track option) {
                                                    <agpr-radio
                                                        [id]="'agpr_aiContextTakeover_option_' + question.id + '_' + $index"
                                                        [name]="'agpr_aiContextTakeover_' + question.id"
                                                        [label]="option"
                                                        [value]="option"
                                                        [(ngModel)]="questionStates[question.id].selectedOption"
                                                        [disabled]="ignoredQuestions[question.id]"
                                                        (ngModelChange)="updateHasAnswers()"
                                                    ></agpr-radio>
                                                }
                                            </div>
                                        }
                                        @case ('text') {
                                            <div class="agpr-aiContextTakeover-chatQuestionFreeText">
                                                <agpr-textarea-input
                                                    [id]="'agpr_aiContextTakeover_freeText_' + question.id"
                                                    class="agpr-aiContextTakeover-chatQuestionFreeTextInput"
                                                    [placeholder]="'Common.prcopilot.textPlaceholder' | localize"
                                                    [(ngModel)]="questionStates[question.id].freeTextInput"
                                                    [disabled]="ignoredQuestions[question.id]"
                                                    (ngModelChange)="updateHasAnswers()"
                                                    [bottomMargin]="false"
                                                ></agpr-textarea-input>
                                            </div>
                                        }
                                    }
                                </div>
                            }

                            <div class="agpr-aiContextTakeover-question">
                                <div class="agpr-aiContextTakeover-chatQuestionHeading">
                                    {{ 'Common.prcopilot.additionalContextQuestion' | localize }}
                                </div>
                                <div class="agpr-aiContextTakeover-chatQuestionFreeText">
                                    <agpr-textarea-input
                                        id="agpr_aiContextTakeover_freeText_freeFormResponse"
                                        class="agpr-aiContextTakeover-chatQuestionFreeTextInput"
                                        [placeholder]="'Common.prcopilot.additionalContextPlaceholder' | localize"
                                        [(ngModel)]="freeTextAnswer"
                                        (ngModelChange)="updateHasAnswers()"
                                    ></agpr-textarea-input>
                                </div>
                            </div>
                        }
                    </agpr-scroll-panel>

                    @if (!isLoading) {
                        <div class="agpr-aiContextTakeover-chatFooter">
                            <agpr-button
                                id="agpr_aiContextTakeover_submitButton"
                                [label]="submitLabel | localize"
                                [style]="buttonTypes.primaryB"
                                [disabled]="!hasAnswers"
                                (click)="submitAll()"
                            ></agpr-button>
                        </div>
                    }
                </div>

                <!-- Right: summary panel -->
                <div class="agpr-aiContextTakeover-summary">
                    <div class="agpr-aiContextTakeover-summaryHeader">
                        <h3 class="agpr-aiContextTakeover-summaryHeading">{{ originalPurposeLabel | localize }}</h3>
                        <p class="agpr-aiContextTakeover-summaryText">{{ originalPurpose }}</p>
                        <agpr-button
                            id="agpr_aiContextTakeover_useOriginalButton"
                            class="agpr-aiContextTakeover-summaryUseInsteadButton"
                            [style]="buttonTypes.tertiary"
                            label="Common.prcopilot.useThisInstead"
                            (click)="useOriginalPurpose()"
                        ></agpr-button>
                    </div>

                    <div class="agpr-aiContextTakeover-summaryContent">
                        <h3 class="agpr-aiContextTakeover-summaryHeading">{{ refinedPurposeLabel | localize }}</h3>
                        <div class="agpr-aiContextTakeover-summaryPanelContent">
                            <div class="agpr-aiContextTakeover-summaryContentHeader">
                                <span class="agpr-aiContextTakeover-refinedPurposeType">{{ badgeText | localize }}</span>
                                <div class="agpr-aiContextTakeover-summaryContentHeaderRight">
                                    <div class="agpr-aiContextTakeover-historyNav">
                                        <agpr-button
                                            id="agpr_aiContextTakeover_undoButton"
                                            class="agpr-aiContextTakeover-historyNavButton"
                                            icon="fa-duotone fa-regular fa-arrow-rotate-left"
                                            [style]="buttonTypes.icon"
                                            [disabled]="!canGoBack"
                                            (click)="previousQuestionState()"
                                        ></agpr-button>
                                        <agpr-button
                                            id="agpr_aiContextTakeover_redoButton"
                                            class="agpr-aiContextTakeover-historyNavButton"
                                            icon="fa-duotone fa-regular fa-arrow-rotate-right"
                                            [style]="buttonTypes.icon"
                                            [disabled]="!canGoForward"
                                            (click)="nextQuestionState()"
                                        ></agpr-button>
                                    </div>
                                </div>
                            </div>
                            <agpr-textarea-input
                                id="agpr_aiContextTakeover_freeText_refinedPurpose"
                                class="agpr-aiContextTakeover-summaryRefinedTextarea"
                                (ngModelChange)="setBadgeState(badgeStateEnum.manuallyEdited)"
                                [(ngModel)]="refinedPurpose"
                                [autoGrow]="true"
                                [rows]="10"
                            ></agpr-textarea-input>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </ng-template>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            id="agpr_aiContextTakeover_cancelButton"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            id="agpr_aiContextTakeover_applyButton"
            [label]="applyLabel"
            [disabled]="refinedPurpose?.trim().length === 0"
            [style]="buttonTypes.primary"
            (click)="apply()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
